// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q67c","delete":"styles_delete__3mIpD","update":"styles_update__24yMg","add":"styles_add__n_XDO"};